module.exports = __webpack_public_path__ + "img/picture_vipkcbj01.e6eba088.png";